import getAxiosInstance from '../../../../../helpers/get_axios_instance'
import lrsAdapter from '../../../../../helpers/lrs_adapter'

export class TablaCamionesVolcadosService {
  static async getDataTablaCamionesVolcados (fechaActualizada) {
    const axios = getAxiosInstance()
    return axios.get(`/consulta_cea_con_volcado?r={"clave":{"fecha_de_volcado": "${fechaActualizada}"}, "orden": ["fecha_de_volcado"]}`).then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }
}
